<template>
  <SubscriptionDetailsModal
      :isVisible="isDetailsModalVisible"
      @closeEmailModal="isDetailsModalVisible = false"
      :currentSubscriber="currentSubscriber"
  />

  <div class="subscribers-admin" v-if="currentUser">
    <div class="page-header">
      <h1>Subskrybenci</h1>
      <button class="btn-outline" @click="resetFilters">Resetuj filtry</button>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Filtrowanie i wyszukiwanie</h2>

        <div class="filters-grid">
          <div class="form-group">
            <label for="plan">Plan subskrypcji</label>
            <select name="plan" id="plan" v-model="plan" @change="filterUsers">
              <option value="0">Wszyscy</option>
              <option v-for="sub in subscriptions" :value="sub.id" :key="sub.id">{{ sub.name }}</option>
            </select>
          </div>

          <div class="form-group">
            <label for="filter">Szukaj po</label>
            <select name="filter" id="filter" v-model="searcher.choosedFilter">
              <option value="">Wybierz filtr</option>
              <option :value="item.value" v-for="(item, index) in searcher.filters" :key="index">{{ item.name }}</option>
            </select>
          </div>

          <div class="form-group">
            <label for="phrase">Fraza</label>
            <input
                id="phrase"
                type="text"
                v-model="searcher.searchPhrase"
                :disabled="!searcher.choosedFilter"
                :placeholder="searchPlaceholder"
                @keyup.enter="searcher.searchPhrase ? filterUsers() : null"
            >
          </div>
        </div>

        <div class="filters-row">
          <label class="checkbox-row" for="smsUsers">
            <input type="checkbox" id="smsUsers" v-model="smsUsers" @change="filterUsers">
            <span>Pokaż użytkowników z wysłanymi powiadomieniami SMS</span>
          </label>

          <div class="filters-actions">
            <button class="btn-green" @click="() => { searcher.searchPhrase ? filterUsers() : null; }">Szukaj</button>
            <button class="btn-outline" @click="resetFilters">Resetuj</button>
            <img v-if="searcher.loading" class="loading" src="@/assets/icons/loading.gif" alt="ładowanie">
          </div>
        </div>
      </div>

      <div class="toolbar-row">
        <div class="toolbar-group">
          <span>Pokaż na stronie:</span>
          <select
              name="usersLimit"
              id="usersLimit"
              class="users-limit-select"
              v-model.number="usersList.limit"
              @change="() => { usersList.page = 1; filterUsers(); }"
          >
            <option :value="1">1</option>
            <option :value="10">10</option>
            <option :value="16">16</option>
            <option :value="22">22</option>
            <option :value="28">28</option>
            <option :value="34">34</option>
          </select>
        </div>

        <div class="pagination">
          <button class="btn-outline" @click="prevPage" :disabled="usersList.page <= 1">
            &#8592; Poprzednia
          </button>
          <span class="page-info">Strona: {{ usersList.page }}/{{ totalPages }}</span>
          <button class="btn-outline" @click="nextPage" :disabled="usersList.page >= totalPages">
            Następna &#8594;
          </button>
        </div>
      </div>
    </div>

    <div class="section-card table-card">
      <div class="section-card-header">
        <h2>Lista subskrybentów</h2>
      </div>

      <div class="table-wrapper" v-if="usersList.usersList">
        <table class="subscribers-table" v-if="usersList.usersList.length > 0">
          <thead>
          <tr>
            <th>ID</th>
            <th>Adres e-mail</th>
            <th>Status</th>
            <th>Status SMS</th>
            <th>Akcje</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="user in usersList.usersList" :key="user.id">
            <td>{{ user.id }}</td>
            <td>{{ user.email }}</td>
            <td :class="user.subscription ? 'green-text' : 'red-text'">
              {{ user.role.id === 2 ? (user.subscription ? 'subskrybent' : 'nie zasubskrybował') : '-' }}
            </td>
            <td :class="user.role.id === 2 ? (user.subscription ? (user.sending_sms_active === null || user.sending_sms_active ? 'green-text' : 'red-text') : 'red-text') : 'red-text'">
              {{ user.role.id === 2 ? (user.subscription ? (user.sending_sms_active === null || user.sending_sms_active ? 'aktywne' : 'nieaktywne') : '-') : '-' }}
            </td>
            <td>
              <div class="actions-wrap">
                <RouterLink v-if="user.role.id === 2" :to="`/browse/user/${user.id}`">
                  <button class="btn-outline">Wizytówka</button>
                </RouterLink>

                <button
                    v-if="user.role.id === 2 && !user.isAddingSubscription && !user.subscription"
                    class="btn-green"
                    @click="user.isAddingSubscription = true"
                >
                  Nadaj subskrypcję
                </button>

                <select
                    name="addSubscriptionPlanSelect"
                    v-if="user.isAddingSubscription"
                    id="addSubscriptionPlanSelect"
                    v-model="user.addSubscriptionPlanSelect"
                    @change="addSubscription(user.id, user.addSubscriptionPlanSelect)"
                >
                  <option v-for="sub in subscriptions" :value="sub.id" :key="sub.id">{{ sub.name }}</option>
                </select>

                <button v-if="user.isAddingSubscription" class="btn-outline btn-icon" @click="user.isAddingSubscription = false">
                  <img src="@/assets/icons/x.svg" alt="zamknij">
                </button>

                <button
                    v-if="user.role.id === 2 && user.subscription"
                    class="btn-danger"
                    @click="removeSubscription(user.id, user.subscription.subscription.id)"
                >
                  Anuluj subskrypcję
                </button>

                <button
                    v-if="user.role.id === 2 && user.subscription"
                    class="btn-danger"
                    @click="blockSMS(user.id)"
                >
                  Zablokuj SMS
                </button>

                <button
                    v-if="user.role.id === 2 && user.subscription"
                    class="btn-primary"
                    @click="() => { isDetailsModalVisible = true; currentSubscriber = user; }"
                >
                  Szczegóły
                </button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <div v-else class="empty-state">
          <p>Nie znaleziono subskrybentów.</p>
        </div>
      </div>

      <div v-else class="empty-state">
        <p>Ładowanie danych...</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SubscriptionDetailsModal from '@/components/SpecialComponents/SubscriptionDetailsModal.vue';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'SubscribersList',
  components: { SubscriptionDetailsModal },
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      smsUsers: false,
      isDetailsModalVisible: false,
      plan: '0',
      subscriptions: [],
      usersList: {
        usersList: null,
        page: 1,
        limit: 10,
        usersCount: null,
      },
      currentSubscriber: null,
      searcher: {
        searchPhrase: '',
        choosedFilter: '',
        loading: false,
        filters: [
          { name: 'adres e-mail', value: 'email' },
          { name: 'imię i nazwisko', value: 'name' },
        ],
      },
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
    totalPages() {
      const pages = Math.ceil((this.usersList.usersCount || 0) / this.usersList.limit);
      return pages > 0 ? pages : 1;
    },
    searchPlaceholder() {
      if (!this.searcher.choosedFilter) return 'Najpierw wybierz filtr';
      const filter = this.searcher.filters.find(item => item.value === this.searcher.choosedFilter);
      return filter ? filter.name : 'Wpisz frazę';
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
    this.getPlans();
  },
  methods: {
    getPlans() {
      axios.post('/SubscriptionSearch', {
        page: 1,
        limit: 10,
      }).then(res => {
        this.subscriptions = res.data.items;
        this.plan = this.subscriptions[0] ? this.subscriptions[0].id : '0';
      }).then(() => {
        this.getSubscribers();
      }).catch(() => {});
    },
    getSubscribers() {
      const ob = {
        page: this.usersList.page,
        limit: this.usersList.limit,
        subscription_id: this.plan,
      };
      if (this.smsUsers) {
        ob.have_sent_sms = true;
      }
      axios.post('/Users', ob).then((res) => {
        this.usersList.usersCount = res.data.count;
        this.usersList.usersList = res.data.items;
      });
    },
    filterUsers() {
      this.searcher.loading = true;
      const ob = {
        page: this.usersList.page,
        limit: this.usersList.limit,
        subscription_id: this.plan,
      };

      switch (this.searcher.choosedFilter) {
        case 'email':
          ob.email = this.searcher.searchPhrase;
          break;
        case 'name':
          ob.name = this.searcher.searchPhrase;
          break;
      }

      if (this.smsUsers) {
        ob.have_sent_sms = true;
      }

      axios.post('/Users', ob).then((res) => {
        this.usersList.usersCount = res.data.count;
        this.usersList.usersList = res.data.items;
      }).catch(() => {
      }).finally(() => {
        this.searcher.loading = false;
      });
    },
    resetFilters() {
      this.smsUsers = false;
      this.searcher.searchPhrase = '';
      this.searcher.choosedFilter = '';
      this.usersList.page = 1;
      this.getSubscribers();
    },
    prevPage() {
      if (this.usersList.page > 1) {
        this.usersList.page -= 1;
        this.filterUsers();
      }
    },
    nextPage() {
      if (this.usersList.page < this.totalPages) {
        this.usersList.page += 1;
        this.filterUsers();
      }
    },
    addSubscription(id, subid) {
      axios.post('/AddUserToSubscription', {
        user_id: id,
        subscription_id: subid,
      }, authHeader()).then((res) => {
        if (String(res.status).charAt(0) === '2') {
          this.appStore.setIsSuccess('Pomyślnie nadano subskrypcję');
          this.getSubscribers();
        }
      });
    },
    removeSubscription(id, subid) {
      axios.post('/DeleteUserFromSubscription', {
        user_id: id,
        subscription_id: subid,
      }, authHeader()).then((res) => {
        if (String(res.status).charAt(0) === '2') {
          this.appStore.setIsSuccess('Pomyślnie odpięto subskrypcję');
          this.getSubscribers();
        }
      });
    },
    blockSMS(id) {
      axios.get(`/SendingSmsBan/${id}`, authHeader()).then(res => {
        if (String(res.status).charAt(0) === '2') {
          this.appStore.setIsSuccess('Pomyślnie zablokowano SMS dla użytkownika');
          this.getSubscribers();
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.subscribers-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 20px;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 14px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
}

.form-group input,
.form-group select,
.actions-wrap select {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 1.4rem;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
  background: #fff;
}

.form-group input:focus,
.form-group select:focus,
.actions-wrap select:focus {
  border-color: #10b981;
}

.filters-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.checkbox-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #374151;
  font-size: 1.4rem;
}

.checkbox-row input {
  accent-color: #10b981;
  width: 16px;
  height: 16px;
}

.filters-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.loading {
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.toolbar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 10px;
  border-top: 1px solid #e5e7eb;
}

.toolbar-group {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #374151;
  font-size: 1.4rem;
}

.users-limit-select {
  width: 70px;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.page-info {
  font-size: 1.5rem;
  color: #6b7280;
  font-weight: 500;
  min-width: 140px;
  text-align: center;
}

.table-card {
  margin-bottom: 0;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.subscribers-table {
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.subscribers-table th,
.subscribers-table td {
  padding: 12px;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
  font-size: 1.4rem;
  vertical-align: middle;
}

.subscribers-table thead th {
  background: #f9fafb;
  color: #374151;
  font-weight: 700;
  border-bottom: 1px solid #e5e7eb;
}

.subscribers-table tbody tr:last-child td {
  border-bottom: none;
}

.subscribers-table tbody tr:hover td {
  background: #fcfcfd;
}

.actions-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.green-text {
  color: #16a34a;
  font-weight: 600;
}

.red-text {
  color: #dc2626;
  font-weight: 600;
}

.empty-state {
  text-align: center;
  padding: 28px;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  font-size: 1.35rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

.btn-green {
  background-color: #10b981;
  color: #fff;
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  font-size: 1.35rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-green:hover {
  background-color: #059669;
}

.btn-danger {
  background-color: #dc3545;
  color: #fff;
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  font-size: 1.35rem;
  font-weight: 600;
  cursor: pointer;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.35rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-icon {
  padding: 6px 10px;
  display: inline-flex;
  align-items: center;
}

.btn-icon img {
  width: 16px;
  height: 16px;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .filters-grid {
    grid-template-columns: 1fr;
  }

  .toolbar-row {
    flex-direction: column;
    align-items: stretch;
  }

  .pagination {
    justify-content: space-between;
  }
}

@media (max-width: 480px) {
  .subscribers-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .filters-actions {
    width: 100%;
  }

  .btn-primary,
  .btn-green,
  .btn-danger,
  .btn-outline {
    width: 100%;
    text-align: center;
  }

  .actions-wrap {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>